import React, { Component } from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';
import './styles.css';
import { location, appointment } from '../../assets/icons';

const formatLongDate = (millis) => {
  const momentDate = moment(millis);
  return `${momentDate.format('dddd,')}\n${momentDate.format('MMMM Do')}\n${momentDate.format('h:mma')}`
}
// TODO: Add alternative PHONE icon from APPOINTMENT
export default class UpcomingAppointmentWidget extends Component {

  static propTypes = {
    location: PropTypes.string.isRequired,
    address: PropTypes.shape({
      street: PropTypes.string,
      city: PropTypes.string,
      state: PropTypes.string,
    }).isRequired,
    date: PropTypes.number.isRequired,
    type: PropTypes.string
  }

  static defaultProps = {
    location: 'Flatiron',
    address: {
      street: '155 East York St',
      city: 'New York',
      state: 'NY'
    },
    date: Date.now(),
    type: ""
  }

  render() {
    const { locale, address, date, type, phone } = this.props;
    const { street, city, state } = address;
    return (
      <div className="appointment__widget">
        <div className="type__widget__header appointment__widget__header">Upcoming Appointment:</div>
        <div className="type__date appointment__widget__date">{formatLongDate(date)}</div>
        <div className="appointment__widget__location">
          <img src={type === "Phone Consultation" ? appointment : location } alt={type + "icon"} />
          <div className="appointment__widget__address">
          {type !== "Phone Consultation" ? (
            <React.Fragment>
              <div className="type__address__location">{locale}</div>
              <div className="type__address">{street}</div>
              <div className="type__address">{`${city} ${state}`}</div>
            </React.Fragment>
            ) : (
              <React.Fragment>
                <div className="type__phone">Tel:{" " + phone}</div>
              </React.Fragment>
            )}
          </div>
        </div>
      </div>
    );
  }
};



// WEBPACK FOOTER //
// ./src/components/UpcomingAppointmentWidget/UpcomingAppointmentWidget.js